module.exports = "https://static.wmbcdn.com/uniweb/images/7be32ab22e2557cc500ab440707b9332.svg";